import { Outlet } from 'react-router';
import { DefaultLayout } from './DefaultLayout';
import { GoBack } from './GoBack';

export const DefaultLayoutWrapper = () => (
  <DefaultLayout>
    <GoBack />
    <Outlet />
  </DefaultLayout>
);
